var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c("b-col", [
            _c("h2", [
              _c("span", { staticClass: "ti-settings mr-2" }),
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("message.appSidebar.navItem.account")) +
                  "\n      "
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [
          _c(
            "b-col",
            [
              _c(
                "b-card",
                { staticClass: "rounded-0" },
                [
                  _c("h4", { staticClass: "text-muted font-weight-normal" }, [
                    _c("span", { staticClass: "ti-id-badge mr-2" }),
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("message.accountDetails.title")) +
                        "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("personal-information-form", {
                    attrs: {
                      personalInfo: _vm.personalInfo,
                      onDeleteAvatar: _vm.deleteAvatar,
                      onSubmit: _vm.savePersonalInfo,
                      onSubmitAvatar: _vm.uploadAvatar
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [
          _c(
            "b-col",
            { attrs: { sm: "12", md: "12", lg: "6" } },
            [
              _c(
                "b-card",
                { staticClass: "rounded-0" },
                [
                  _c("h4", { staticClass: "text-muted font-weight-normal" }, [
                    _c("span", { staticClass: "ti-key mr-2" }),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "message.accountDetails.card.title.changePassword"
                          )
                        ) +
                        "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("change-passsword-form", {
                    attrs: {
                      passwordData: _vm.passwordData,
                      onSubmit: _vm.saveChangedPassword
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "mt-sm-4 mt-lg-0",
              attrs: { sm: "12", md: "12", lg: "6" }
            },
            [
              _c(
                "b-card",
                { staticClass: "rounded-0" },
                [
                  _c("h4", { staticClass: "text-muted font-weight-normal" }, [
                    _c("span", { staticClass: "ti-email mr-2" }),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "message.accountDetails.card.title.changeEmail"
                          )
                        ) +
                        "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("account-change-email-form", {
                    ref: "accountChangeEmailForm",
                    on: { submit: _vm.saveChangedEmail }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [
          _vm.isPolicyHolder
            ? _c(
                "b-col",
                [
                  _c(
                    "b-card",
                    { staticClass: "rounded-0 h-100" },
                    [
                      _c(
                        "h4",
                        { staticClass: "text-muted font-weight-normal" },
                        [
                          _c("span", { staticClass: "ti-share-alt mr-2" }),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t(
                                  "message.accountDetails.card.title.powerOfAttorney"
                                )
                              ) +
                              "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("account-power-of-attorney-form", {
                        attrs: {
                          user: _vm.user,
                          onPrintPoaFn: _vm.printPoa,
                          onRevokePoaFn: _vm.revokePoa
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c(
                "b-card",
                { staticClass: "rounded-0 h-100" },
                [
                  _c("h4", { staticClass: "text-muted font-weight-normal" }, [
                    _c("span", { staticClass: "ti-archive mr-2" }),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("message.accountDetails.card.title.deactivate")
                        ) +
                        "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("account-deactivation-form", {
                    attrs: { onDeactivateFn: _vm.deactivateAccount }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77ed43b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77ed43b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/AccountDetails.vue
// module id = 19oK
// module chunks = 1